import React from 'react';
import { ErrorFallback } from './ErrorFallback';

export type AppErrorBoundaryProps = {
  children: React.ReactNode;
  /** When true, render a compact fallback (e.g. for section-level boundaries). */
  compact?: boolean;
};

type State = { error: unknown };

/**
 * Simple React error boundary. Plug in a reporting SDK (Sentry, etc.) inside
 * componentDidCatch if/when this project wants error telemetry.
 */
export class ErrorBoundary extends React.Component<AppErrorBoundaryProps, State> {
  constructor(props: AppErrorBoundaryProps) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: unknown) {
    return { error };
  }

  resetError = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return <ErrorFallback error={this.state.error} resetError={this.resetError} compact={this.props.compact} />;
    }
    return this.props.children;
  }
}

export { ErrorFallback } from './ErrorFallback';
export type { ErrorFallbackProps } from './ErrorFallback';
